import React from 'react';
import {
  FDBox,
  FDPrimaryActionIconButton,
  FDPrimaryActionButton, FDStack, FDClickableText,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';

const TaxDashboardWizardFooterNav = ({
  onNext,
  onNextHref,
  onPrevious,
  disabled,
  loading,
  primaryActionLabel,
  secondaryActionLabel,
  clickableTextLabel = undefined,
  onClickText = undefined,
}) => {
  const isMobile = useMobileLayout();

  return (
    <FDStack direction={'column'} paddingY={5} width={'100%'} alignItems={'center'} spacing={2}>
      <FDStack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'center'} width={'100%'}>
        {onPrevious ? (
          <FDBox>
            <FDPrimaryActionIconButton
              label={secondaryActionLabel}
              onClick={onPrevious}
              loading={loading}
              isFullWidth
              icon={'chevronLeft'}
              {...dataAttrs('back-btn')}
            />
          </FDBox>
        ) : null}
        <FDBox minWidth={160} maxWidth={isMobile ? undefined : 240} width={'100%'}>
          <FDPrimaryActionButton
            label={primaryActionLabel}
            onClick={onNextHref ? undefined : onNext}
            href={onNextHref}
            loading={loading}
            disabled={disabled || !onNext}
            isFullWidth
            {...dataAttrs('continue-btn')}
          />
        </FDBox>

      </FDStack>
      {clickableTextLabel ? (
        <FDClickableText
          appearance={'standalone'}
          label={clickableTextLabel}
          onClick={onClickText}
          {...dataAttrs('tax-dashboard-wizard-extra-nav-btn')}
        />
      ) : null}
    </FDStack>
  );
};
export { TaxDashboardWizardFooterNav };
